import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useTranslateReducer = () =>
  useSelector((state: ApplicationState) => state.translate);
